export default __webpack_public_path__ + "static/media/Modular_Power_System.e1b64c6c.png";